export default "__VITE_ASSET__CCuUX8Wo__"